<template>
  <div class="row">
    <div class="col-5">
      <div class="logo">
        <img :src="logo">
      </div>
    </div>
    <div class="col-7">
      <div class="numbers">
        <p class="card-category">
          {{ smallTitle }}
        </p>
        <p class="card-title" :class="{loading: loading}">
          {{ data.balance === '-' ? '' : '$' }} {{ data.balance === '-' ? data.balance : Number(data.balance).toFixed(2) }}
        </p>
      </div>
    </div>
    <div v-if="data.currentMonth" class="col-12 card-additional-info">
      <p class="text">
        Расходы в текущем месяце
      </p>
      <p class="amount" :class="{loading: loading}">
        $ {{ data.currentMonth }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LuminatiStatsCardTemplate",
  props: {
    data: { type: Object, required: true, },
    smallTitle: { type: String, required: true, },
    loading: { type: Boolean, default: false },
    logo: { type: String, required: true, },
  },

}
</script>

<style scoped>

</style>
